import req from "../http";

const resumeTag = {
  // 取得 履歷分類選項
  getResumeTag(params) {
    return req("get", "/ResumeModule/ResumeTag/Tags", params);
  },

  // 取得 其他分類選項
  getFreeTag(params) {
    return req("get", "/ResumeModule/ResumeTag/FreeTags", params);
  },

  // 取得 履歷分類與其他分類(依ResumeId)
  getTagByResumeId(resumeId) {
    return req("get", `/ResumeModule/ResumeTag/Resume/${resumeId}`);
  },

  // 修改 履歷分類
  putResumeTag(params) {
    return req("put", "/ResumeModule/ResumeTag/Resume", params);
  }
};

export default resumeTag;